import {type FC} from 'react';
import type {PlaylistInfo} from '../types';
import {setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import {ThumbnailCard, ThumbnailImage, VideoTitle} from '../types/Replay.styled.ts';
import useReplayStore from '../../../store/useReplayStore.ts';

interface ThumbnailCardItemProps {
    videoInfo: PlaylistInfo;
    sectionIndex: number;
    itemIndex: number;
}

const ThumbnailCardItem: FC<ThumbnailCardItemProps> = ({videoInfo, sectionIndex, itemIndex}) => {
    const {setLastFocus, handleClick} = useReplayStore();

    const {ref, focused} = useFocusable({
        focusKey: `thumbnail-${sectionIndex}-${itemIndex}-${videoInfo.id}`,
        onFocus: () => {
            if (ref.current) {
                ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'nearest',
                });
            }
        },
        onEnterPress: () => {
            handleClick(videoInfo);
            setLastFocus(`thumbnail-${sectionIndex}-${itemIndex}-${videoInfo.id}`);
        },
        onArrowPress: (direction) => {
            if (itemIndex === 0 && direction === 'left') {
                setFocus('replay');
                return false;
            }
            return true;
        },
    });

    return (
        <>
            <ThumbnailCard ref={ref} $focused={focused} tabIndex={-1} onClick={() => handleClick(videoInfo)}>
                <ThumbnailImage src={videoInfo.snippet.thumbnails.high?.url} alt={videoInfo.snippet.title} />
                <VideoTitle>{videoInfo.snippet.title}</VideoTitle>
            </ThumbnailCard>
        </>
    );
};

export default ThumbnailCardItem;
